export const LimitedTimeOfferExpirationTypeEnum = Object.freeze({
    DATE_TIME_PICKER: 'datetime',
    DELAY: 'delay',
});